.wrap {
  padding: 74px 28px 60px;
  margin-top: 52px;
  text-align: center;
  background: linear-gradient(
    180deg,
    rgba(239, 242, 245, 0) 0%,
    var(--blush) 70px,
    var(--blush) calc(100% - 70px),
    rgba(239, 242, 245, 0) 100%
  );
}
.divider {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-bottom: 42px;
}
.dividerBottom {
  margin-bottom: 0;
  margin-top: 36px;
}
.line {
  width: 46px;
  height: 1px;
  background: var(--rule);
}
.dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: radial-gradient(circle at 32% 28%, #ffffff 0%, #f5ede2 38%, #e0d4c1 70%, #cdbda4 100%);
  box-shadow: 0 2px 5px rgba(120, 100, 70, 0.3);
}
.eyebrow {
  font-family: var(--font-script);
  font-size: 24px;
  color: var(--pink);
}
.title {
  margin: 2px 0 0;
  font-family: var(--font-body);
  font-weight: 400;
  font-size: 27px;
  letter-spacing: 3px;
  text-indent: 2px;
  color: var(--ink-2);
}
.calendar {
  margin-top: 26px;
  padding: 22px 4px 26px;
  border-top: 1px solid var(--rule-3);
  border-bottom: 1px solid var(--rule-3);
  width: 100%;
  box-sizing: border-box;
}
.year {
  font-family: var(--font-label);
  font-size: 11.5px;
  letter-spacing: 5px;
  text-indent: 5px;
  color: var(--muted-3);
}
.month {
  font-family: var(--font-script);
  font-weight: 400;
  font-size: 31px;
  color: var(--pink);
  margin-top: 4px;
}
.calHead {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  margin-top: 22px;
}
.calHeadCell {
  font-family: var(--font-label);
  font-weight: 700;
  font-size: 12.5px;
  padding: 6px 0;
}
.calGrid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  margin-top: 8px;
  row-gap: 12px;
}
.calCell {
  position: relative;
  padding: 7px 0;
  font-family: var(--font-label);
  font-size: 14px;
}
.badge {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 33px;
  height: 33px;
  transform: translate(-50%, -50%);
  background: var(--pink);
  border-radius: 50%;
  box-shadow: 0 3px 8px rgba(16, 26, 43, 0.3);
}
.calNum {
  position: relative;
}
.dateLine {
  margin-top: 22px;
  font-family: var(--font-detail);
  font-weight: 400;
  font-size: 18px;
  line-height: var(--font-detail-line-height);
  letter-spacing: 0.5px;
  color: var(--ink);
}
.venueLine {
  margin-top: 8px;
  font-family: var(--font-detail);
  font-size: 15px;
  line-height: var(--font-detail-line-height);
  letter-spacing: 0.5px;
  color: var(--ink-4);
}
